import { FC } from "react";
import React, { useState } from "react";

import { deleteTeamMember } from "../../network/teamMember";

import DeleteModal from "../common/DeleteModal";
import { queryKeys } from "../../services/react-query/queryKeys";
import queryClient from "../../services/react-query/queryClient";
import { useIntl } from "react-intl";

interface DeleteTeamMemeberProps {
  visible: boolean;
  onClose: () => void;
  teamMemeberData: any;
}

const DeleteTeamMemeber: FC<DeleteTeamMemeberProps> = ({
  visible,
  onClose,
  teamMemeberData,
}) => {
  const intl = useIntl();
  return (
    <DeleteModal
      visible={visible}
      onClose={onClose}
      onDelete={deleteTeamMember}
      data={teamMemeberData?.id}
      confirmationHeader={intl.formatMessage({ id: "tm-delete-confirm" })}
      confirmationText={intl.formatMessage({ id: "tm-delete-desc" })}
      queryKey={queryKeys.listTeamMember}
      successMessage="Category deleted successfully"
      afterDelete={() => {
        queryClient.invalidateQueries([queryKeys.listTeamMember]);
      }}
    />
  );
};

export default DeleteTeamMemeber;
